import React, { useState } from "react";
import api from "../../services/api";

/**
 * R6 A9 — Quick Add Contact from the Contact column.
 */
export default function QuickAddContactModal({ lead, onClose, onCreated }) {
  const [form, setForm] = useState({
    firstName: "", lastName: "", title: "", email: "",
    workPhone: "", mobilePhone: "", homePhone: "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (!lead) return null;

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    if (!form.firstName.trim()) { setError("First name is required"); return; }
    setSaving(true);
    setError("");
    try {
      const currentContacts = Array.isArray(lead.contacts) ? lead.contacts : [];
      await api.updateLead(lead.lead_id, {
        contacts: [
          ...currentContacts,
          {
            ...form,
            // First contact becomes primary; subsequent ones non-primary.
            isPrimary: currentContacts.length === 0,
          },
        ],
      });
      try {
        await api.recordRecentLeadEdit?.({
          leadId: lead.lead_id,
          field: "notes",
          newValue: `Added contact ${form.firstName} ${form.lastName}`.trim(),
          source: "quick_add_contact",
        });
      } catch {}
      onCreated?.();
      onClose?.();
    } catch (e) {
      setError(e?.response?.data?.error || "Failed to add contact");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" role="presentation" onMouseDown={onClose}>
      <div className="modal r6-quick-add-contact" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Add Contact — {lead.company}</h3>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose}>
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-row">
            <div className="form-group">
              <label>First Name *</label>
              <input className="form-control" value={form.firstName} onChange={set("firstName")} />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input className="form-control" value={form.lastName} onChange={set("lastName")} />
            </div>
          </div>
          <div className="form-group">
            <label>Title</label>
            <input className="form-control" value={form.title} onChange={set("title")} />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Email</label>
              <input className="form-control" type="email" value={form.email} onChange={set("email")} />
            </div>
            <div className="form-group">
              <label>Mobile Phone</label>
              <input className="form-control" value={form.mobilePhone} onChange={set("mobilePhone")} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Work Phone</label>
              <input className="form-control" value={form.workPhone} onChange={set("workPhone")} />
            </div>
            <div className="form-group">
              <label>Home Phone</label>
              <input className="form-control" value={form.homePhone} onChange={set("homePhone")} />
            </div>
          </div>
          {error && <div className="error-message">{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? "Saving…" : "Save Contact"}
          </button>
        </div>
      </div>
    </div>
  );
}